import axios from 'axios';
import type { 
  NganhHoc, 
  CreateNganhHocRequest, 
  UpdateNganhHocRequest,
  ImportNganhHocData,
  ApiResponse,
  PaginationParams 
} from '../../../shared/types';

const API_BASE_URL = '/api/v1/nganhhoc';

export interface NganhHocListResponse {
  success: boolean;
  data: NganhHoc[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  message: string;
}

export interface NganhHocResponse {
  success: boolean;
  data: NganhHoc;
  message: string;
}

export interface ImportNganhHocResponse {
  success: boolean;
  data: {
    inserted: NganhHoc[];
    errors: Array<{
      item: ImportNganhHocData;
      error: string;
    }>;
  };
  message: string;
}

class NganhHocService {
  // Lấy danh sách ngành học
  async getNganhHoc(params?: PaginationParams): Promise<NganhHocListResponse> {
    const response = await axios.get<NganhHocListResponse>(API_BASE_URL, { params });
    return response.data;
  }

  // Lấy thông tin chi tiết một ngành học
  async getNganhHocById(id: string): Promise<NganhHocResponse> {
    const response = await axios.get<NganhHocResponse>(`${API_BASE_URL}/${id}`);
    return response.data;
  }

  // Tạo ngành học mới
  async createNganhHoc(data: CreateNganhHocRequest): Promise<NganhHocResponse> {
    const response = await axios.post<NganhHocResponse>(API_BASE_URL, data);
    return response.data;
  }

  // Cập nhật thông tin ngành học
  async updateNganhHoc(id: string, data: UpdateNganhHocRequest): Promise<NganhHocResponse> {
    const response = await axios.put<NganhHocResponse>(`${API_BASE_URL}/${id}`, data);
    return response.data;
  }

  // Xóa ngành học
  async deleteNganhHoc(id: string): Promise<ApiResponse> {
    const response = await axios.delete<ApiResponse>(`${API_BASE_URL}/${id}`);
    return response.data;
  }

  // Import ngành học từ Excel
  async importNganhHoc(items: ImportNganhHocData[]): Promise<ImportNganhHocResponse> {
    const response = await axios.post<ImportNganhHocResponse>(`${API_BASE_URL}/import`, { items });
    return response.data;
  }

  // Xuất template Excel
  async downloadTemplate(): Promise<Blob> {
    const response = await axios.get(`${API_BASE_URL}/template`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export default new NganhHocService(); 